export const STORAGE_KEYS = {
	ACCESS_TOKEN: "accessToken",
	REFRESH_TOKEN: "refreshToken",
	ADMIN_SESSION: "adminSession",
	PRINCIPAL: "principal",
	LOCATION_ID: "locationId",
	NATS_BROKER_URL: "natsBrokerUrl",
	NATS_USERNAME: "natsUsername",
	NATS_PASSWORD: "natsPassword",
} as const;